"use client";

import { Home, Upload, Plus, ListMusic } from "lucide-react";
import { SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@src/components/ui/sidebar";
import { paths } from "@src/utils/paths";
import { usePathname } from "next/navigation";
import { SidebarLink } from "./SidebarLink";
import { useFeatureFlags } from "./providers/FeatureFlagsProvider";
export function LibraryNav() {
  const {
    createSongFlowEnabled
  } = useFeatureFlags();
  const pathname = usePathname();
  return <SidebarGroup data-sentry-element="SidebarGroup" data-sentry-component="LibraryNav" data-sentry-source-file="LibraryNav.tsx">
      <SidebarGroupLabel data-sentry-element="SidebarGroupLabel" data-sentry-source-file="LibraryNav.tsx">Library</SidebarGroupLabel>
      <SidebarGroupContent data-sentry-element="SidebarGroupContent" data-sentry-source-file="LibraryNav.tsx">
        <SidebarMenu data-sentry-element="SidebarMenu" data-sentry-source-file="LibraryNav.tsx">
          <SidebarMenuItem data-sentry-element="SidebarMenuItem" data-sentry-source-file="LibraryNav.tsx">
            <SidebarMenuButton asChild isActive={pathname === paths.home} data-sentry-element="SidebarMenuButton" data-sentry-source-file="LibraryNav.tsx">
              <SidebarLink href={paths.home} data-ph-capture-attribute-action="nav-all-songs" data-sentry-element="SidebarLink" data-sentry-source-file="LibraryNav.tsx">
                <Home className="h-4 w-4" data-sentry-element="Home" data-sentry-source-file="LibraryNav.tsx" />
                <span>Home</span>
              </SidebarLink>
            </SidebarMenuButton>
          </SidebarMenuItem>

          <SidebarMenuItem data-sentry-element="SidebarMenuItem" data-sentry-source-file="LibraryNav.tsx">
            <SidebarMenuButton asChild isActive={pathname === paths.playlists} data-sentry-element="SidebarMenuButton" data-sentry-source-file="LibraryNav.tsx">
              <SidebarLink href={paths.playlists} data-ph-capture-attribute-action="nav-playlists" data-sentry-element="SidebarLink" data-sentry-source-file="LibraryNav.tsx">
                <ListMusic className="h-4 w-4" data-sentry-element="ListMusic" data-sentry-source-file="LibraryNav.tsx" />
                <span>Playlists</span>
              </SidebarLink>
            </SidebarMenuButton>
          </SidebarMenuItem>

          {createSongFlowEnabled ? <SidebarMenuItem>
              <SidebarMenuButton asChild>
                <SidebarLink href={paths.newSong()} data-ph-capture-attribute-action="nav-new-song">
                  <Plus className="h-4 w-4" />
                  <span>New song</span>
                </SidebarLink>
              </SidebarMenuButton>
            </SidebarMenuItem> : <SidebarMenuItem>
              <SidebarMenuButton asChild>
                <SidebarLink href={paths.upload()} data-ph-capture-attribute-action="nav-upload">
                  <Upload className="h-4 w-4" />
                  <span>Upload</span>
                </SidebarLink>
              </SidebarMenuButton>
            </SidebarMenuItem>}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>;
}